(function () {
  class GameStakeSelection extends PIXI.Container {
    constructor(json) {
      super();

      this.json = json;

      this._countButtonRows = json.countButtonRows;
      this._countButtonsPerRow = json.countButtonsPerRow;
      this._buttonSprite = json.buttonSprite;
      this._buttonTextFontWhite = json.buttonTextFontWhite;
      this._buttonTextFontGreen = json.buttonTextFontGreen;
      this._buttonTextMaxWidth = json.buttonTextMaxWidth;
      this._buttonTextPosOffset = json.buttonTextPosOffset;
      this._screenMaskTextId = json.screenMaskTextId;

      this._goldenBetPlatformEnabled = false;
      this._goldenBetPlatformVisible = false;

      if (this._buttonTextPosOffset === undefined) {
        this._buttonTextPosOffset = { x: 0, y: 0 };
      }

      if (this._countButtonRows === undefined) {
        this._countButtonRows = 3;
      }

      this._initialLayoutDone = false;
      this._selectedIndex = -1;

      this._goldenBetSelected = false;
      this._canPlaceGoldenBet = false;
      this._goldenBetStakes = undefined;
      this._availableStakes = undefined;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("game:modal", this.onModal.bind(this));

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      this.isActive = false;
      this.visible = false;
    }

    ////////////////////////////////////
    onModal(msg) {
      // Pressing max bet or lucky bet takes us out of modal but we are still visible, keep modal
      // This means the dialog will be still open allowing the player to spin behind the stake dialog - go back to modal if
      // the dialog is still open

      if (this.isActive && msg.reason === undefined) {
        messageBus.post("game:modal", { reason: "Stake dialog open" });
      }
    }

    initialise() {
      const self = this;

      const stakeController = resourceManager.getController("stakeController");

      //this._bg = resourceManager.get(this.json.bgId);
      this._buttonsContainer = resourceManager.get(
        this.json.buttonsContainerId
      );
      this._closeButton = resourceManager.get(this.json.closeButtonId);
      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        soundManager.play("buttonPressed");
        self.closeDialog();
        self._cancelledCallback();
      };
      this._continueButton = resourceManager.get(this.json.continueButtonId);
      this._continueButton.mousedown = this._continueButton.touchstart =
        function () {
          soundManager.play("buttonPressed");
          self.continuePressed();
        };
      this._continueButtonWhiteText = resourceManager.get(
        this.json.continueButtonUnselectedTextId
      );
      this._continueButtonGreenText = resourceManager.get(
        this.json.continueButtonSelectedTextId
      );
      this._continueButtonGreenText.visible = false;

      this._goldenBetButtonContainer = resourceManager.get(
        this.json.goldenBetButtonContainer
      );

      this._goldenBetButtonOn = resourceManager.get(
        this.json.goldenBetButtonOnId
      );
      this._goldenBetButtonOn.mousedown = this._goldenBetButtonOn.touchstart =
        this.goldenBetOnPressed.bind(this);

      this._goldenBetButtonOff = resourceManager.get(
        this.json.goldenBetButtonOffId
      );
      this._goldenBetButtonOff.mousedown = this._goldenBetButtonOff.touchstart =
        this.goldenBetOffPressed.bind(this);

      //TODO: HB Add disabled img to the golden bet

      // this._glow = resourceManager.get(this.json.goldenBetButtonGlow);
      // this._glow.alpha = 1;
      // this._glowAnim = gsap
      //   .timeline({ repeat: -1, paused: true })
      //   .call(() => {
      //     this._glow.alpha = 1;
      //   })
      //   .to(this._glow, {
      //     duration: 2,
      //     alpha: 0.2,
      //   })
      //   .to(this._glow, {
      //     duration: 1,
      //     alpha: 1,
      //   });
      // this._glow.visible = false;

      const maxNumStakeButtons = stakeController.Stakes.length;

      this._stakeButtons = [];
      let stake;
      for (let index = 0; index < maxNumStakeButtons; ++index) {
        let maxWidth = this._buttonTextMaxWidth;
        let maxWidthLB = this._buttonTextMaxWidth;
        if (maxWidth === undefined) {
          maxWidth = 80;
        }
        if (maxWidthLB === undefined) {
          maxWidthLB = 80;
        }
        if (this.json.maxWidthPerValue !== undefined) {
          stake = stakeController.Stakes[index];
          for (let i = 0; i < this.json.maxWidthPerValue.length; ++i) {
            if (stake < this.json.maxWidthPerValue[i].lessThan) {
              maxWidth = this.json.maxWidthPerValue[i].maxWidth;
              break;
            }
          }
        }
        if (this.json.maxWidthPerValueLuckyBet !== undefined) {
          stake = stakeController.Stakes[index];
          for (let i = 0; i < this.json.maxWidthPerValueLuckyBet.length; ++i) {
            if (stake < this.json.maxWidthPerValueLuckyBet[i].lessThan) {
              maxWidthLB = this.json.maxWidthPerValueLuckyBet[i].maxWidth;
              break;
            }
          }
        }
        const button = resourceManager.createObject(
          "sprite",
          "button" + index,
          this._buttonsContainer,
          { fileName: this._buttonSprite, anchor: 0.5 }
        );
        const buttonTextWhite = resourceManager.createObject(
          "text",
          "button" + index + "whiteText",
          button,
          {
            text: gdk.formatCurrency(stakeController.Stakes[index]),
            fontDefinition: this._buttonTextFontWhite,
            x: this._buttonTextPosOffset.x,
            y: this._buttonTextPosOffset.y,
            maxWidth: maxWidth,
          }
        );

        const buttonTextGreen = resourceManager.createObject(
          "text",
          "button" + index + "greenText",
          button,
          {
            text: gdk.formatCurrency(stakeController.Stakes[index]),
            fontDefinition: this._buttonTextFontGreen,
            x: this._buttonTextPosOffset.x,
            y: this._buttonTextPosOffset.y,
            maxWidth: maxWidth,
          }
        );

        const buttonTextWhiteLuckyBet = resourceManager.createObject(
          "text",
          "button" + index + "whiteTextLB",
          button,
          {
            text: gdk.formatCurrency(stakeController.Stakes[index]),
            fontDefinition: this._buttonTextFontWhite,
            x: this._buttonTextPosOffset.x,
            y: this._buttonTextPosOffset.y,
            maxWidth: maxWidthLB,
          }
        );

        const buttonTextGreenLuckyBet = resourceManager.createObject(
          "text",
          "button" + index + "greenTextLB",
          button,
          {
            text: gdk.formatCurrency(stakeController.Stakes[index]),
            fontDefinition: this._buttonTextFontGreen,
            x: this._buttonTextPosOffset.x,
            y: this._buttonTextPosOffset.y,
            maxWidth: maxWidthLB,
          }
        );

        button.mousedown = button.touchstart = function () {
          self.stakeSelected(index);
          soundManager.play("buttonPressed");
          game.resetWinnings();
        };

        buttonTextGreen.visible = false;
        this._stakeButtons.push({
          button,
          buttonTextWhite,
          buttonTextGreen,
          buttonTextWhiteLuckyBet,
          buttonTextGreenLuckyBet,
          stake,
        });
      }

      if (this._countButtonRows === undefined) {
        this._countButtonsPerRow = Math.floor(
          maxNumStakeButtons / this._countButtonRows
        );
      }
      if (
        this._countButtonRows * this._countButtonsPerRow <
        maxNumStakeButtons
      ) {
        ++this._countButtonRows;
      }
    }

    onGameConfigEvent(configEvent) {
      this.initialise();

      resourceManager.get(
        "uiContainer:buttonContainer:stake:glow"
      ).visible = false;

      this._goldenBetPlatformEnabled =
        configEvent.data.uiElements.btnUpstake.enabled;
      this._goldenBetPlatformVisible =
        configEvent.data.uiElements.btnUpstake.visible;

      this._goldenBetStakes =
        configEvent.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes.map(
          function (x) {
            return x * configEvent.data.slotConfig.defaultNumLines;
          }
        );
    }

    onOrientationChange() {
      if (resourceManager.getController("stakeController")) {
        this.updateLayout();
      }
    }

    updateMaxWidths(buttonWidth) {
      if (
        this._buttonTextMaxWidth === undefined &&
        this.json.maxWidthPerValue === undefined
      ) {
        const width = buttonWidth * 0.8;
        this._stakeButtons.forEach(function (button) {
          button.buttonTextWhite.maxWidth = width;
          button.buttonTextWhite.Props.maxWidth = width;
          button.buttonTextWhite.checkMaxWidth();
          button.buttonTextGreen.maxWidth = width;
          button.buttonTextGreen.Props.maxWidth = width;
          button.buttonTextGreen.checkMaxWidth();
        });
      }
    }

    updateStakes(stakes) {
      this._stakeButtons.forEach(function (button, i) {
        button.buttonTextWhite.setText(gdk.formatCurrency(stakes[i]));
        button.buttonTextGreen.setText(gdk.formatCurrency(stakes[i]));
        button.buttonTextWhiteLuckyBet.setText(gdk.formatCurrency(stakes[i]));
        button.buttonTextGreenLuckyBet.setText(gdk.formatCurrency(stakes[i]));
      });
    }

    goldenBetOnPressed() {
      this._goldenBetButtonOn.interactive = false;
      this._goldenBetButtonOff.interactive = true;

      this._goldenBetButtonOn.visible = false;
      this._goldenBetButtonOff.visible = true;

      this._goldenBetSelected = false;

      // this._glowAnim.pause();
      // this._glow.visible = false;

      let encoreButtonLB = resourceManager.get("goldenBetToggleButton");
      encoreButtonLB.onPressedCallback();

      var stakeController = resourceManager.getController("stakeController");
      this.updateStakes(stakeController.Stakes);

      this.toggleGoldenBetStakes(false);
    }

    goldenBetOffPressed() {
      this._goldenBetButtonOn.interactive = true;
      this._goldenBetButtonOff.interactive = false;

      this._goldenBetButtonOn.visible = true;
      this._goldenBetButtonOff.visible = false;

      this._goldenBetSelected = true;

      // this._glowAnim.play(0);
      // this._glow.visible = true;

      let encoreButtonLB = resourceManager.get("goldenBetToggleButton");
      encoreButtonLB.onPressedCallback();

      var stakeController = resourceManager.getController("stakeController");
      this.updateStakes(stakeController.Stakes);

      this.toggleGoldenBetStakes(true);
    }

    updateLayout() {
      const stakeController = resourceManager.getController("stakeController");
      const maxNumStakeButtons = stakeController.Stakes.length;

      const buttonWidth =
        this._stakeButtons[0].button.texture.width *
        resourceManager.selectedAssetResolution.scaleFactor;
      const buttonHeight =
        this._stakeButtons[0].button.texture.height *
        resourceManager.selectedAssetResolution.scaleFactor;

      this.updateMaxWidths(buttonWidth);

      const allButtonsWidth = buttonWidth * this._countButtonsPerRow;
      const allButtonsHeight = buttonHeight * this._countButtonRows;

      const firstButtonX = -allButtonsWidth / 2;
      const firstButtonY = -allButtonsHeight / 2;
      let x = firstButtonX + buttonWidth / 2;
      let y = firstButtonY + buttonHeight / 2;
      let count = 0;
      for (let row = 0; row < this._countButtonRows; ++row) {
        for (let i = 0; i < this._countButtonsPerRow; ++i) {
          const index = i + row * this._countButtonsPerRow;
          this._stakeButtons[index].button.position.set(x, y);
          x += buttonWidth;
          ++count;
          if (count >= maxNumStakeButtons) {
            break;
          }
        }
        x = firstButtonX + buttonWidth / 2;
        y += buttonHeight;
        if (count >= maxNumStakeButtons) {
          break;
        }
      }
    }

    resetButtons() {
      this._stakeButtons.forEach(function (button) {
        button.buttonTextWhite.visible = gameData.encoreEnabled ? false : true;
        button.buttonTextWhiteLuckyBet.visible = gameData.encoreEnabled
          ? true
          : false;
        button.buttonTextGreen.visible = false;
        button.buttonTextGreenLuckyBet.visible = false;
      });
    }

    toggleButtons(enable) {
      this._stakeButtons.forEach(function (button) {
        button.button.interactive = enable;
      });
    }

    openDialog(stakes, selectedCallback, cancelledCallback) {
      const self = this;
      this.isActive = true;

      this._selectedCallback = selectedCallback;
      this._cancelledCallback = cancelledCallback;
      if (!this._initialLayoutDone) {
        this._initialLayoutDone = true;
        this.updateLayout();
      }

      this._screenMask = resourceManager.get(this._screenMaskTextId);
      this._screenMask.interactive = true;
      this._screenMask.visible = true;
      this._screenMask.mousedown = this._screenMask.touchstart = function () {
        self.closeDialog();
        self._cancelledCallback();
      };

      resourceManager.get(
        "uiContainer:buttonContainer:stake:glow"
      ).visible = true;

      this.toggleButtons(true);

      this.resetButtons();

      this._screenMask.show(true);
      this.visible = true;

      this._screenMask.interactive = true;

      this._continueButton.alpha = 0.7;
      this._continueButtonWhiteText.visible = true;
      this._continueButtonGreenText.visible = false;
      this._continueButton.interactive = false;
      this._closeButton.interactive = true;

      // set correct state of dialog golden bet button on entry
      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      this._goldenBetButtonOn.interactive =
        goldenBetButton._flags.showGoldenBetActive &&
        this._goldenBetPlatformEnabled;
      this._goldenBetButtonOff.interactive =
        !goldenBetButton._flags.showGoldenBetActive &&
        this._goldenBetPlatformEnabled;

      this._goldenBetButtonOn.visible =
        goldenBetButton._flags.showGoldenBetActive &&
        this._goldenBetPlatformVisible;
      this._goldenBetButtonOff.visible =
        !goldenBetButton._flags.showGoldenBetActive &&
        this._goldenBetPlatformVisible;

      let luckyBetOn =
        goldenBetButton._flags.showGoldenBetActive &&
        this._goldenBetPlatformEnabled;

      this._goldenBetSelected = luckyBetOn;
      this.toggleGoldenBetStakes(luckyBetOn);

      // if (luckyBetOn) {
      //   this._glowAnim.play(0);
      //   this._glow.visible = true;
      // } else {
      //   this._glowAnim.pause();
      //   this._glow.visible = false;
      // }

      this._canPlaceGoldenBet = resourceManager
        .get("goldenBetToggleButton")
        .getCanPlaceBet();

      this._goldenBetButtonContainer.visible = this._canPlaceGoldenBet;

      const stakeController = resourceManager.getController("stakeController");
      this.updateStakes(stakeController.Stakes);

      this.stakeSelected(stakes.indexOf(stakeController.CurrentStake));
    }

    stakeSelected(index) {
      this.resetButtons();
      !gameData.encoreEnabled
        ? (this._stakeButtons[index].buttonTextGreen.visible = true)
        : (this._stakeButtons[index].buttonTextGreenLuckyBet.visible = true);
      this._stakeButtons[index].buttonTextWhite.visible = false;
      this._continueButton.alpha = 1;
      this._continueButtonWhiteText.visible = false;
      this._continueButtonGreenText.visible = true;
      this._continueButton.interactive = true;
      this._selectedIndex = index;

      this._selectedCallback(this._selectedIndex);
      messageBus.post("game:modal", { reason: "stakeSelection" });

      this._canPlaceGoldenBet = resourceManager
        .get("goldenBetToggleButton")
        .getCanPlaceBet();

      this._goldenBetButtonContainer.visible = this._canPlaceGoldenBet;
    }

    toggleGoldenBetStakes(show) {
      if (show) {
        this._stakeButtons.forEach((button) => {
          if (!this._goldenBetStakes.includes(button.stake)) {
            button.button.visible = false;
          }
        });
      } else {
        this._stakeButtons.forEach((button) => {
          button.button.visible = true;
        });
      }
    }

    continuePressed() {
      gameController.stakeChanged = true;
      this.isActive = false;
      this._selectedCallback(this._selectedIndex);
      this.closeDialog();
    }

    closeDialog() {
      this.isActive = false;
      this._continueButton.interactive = false;
      this.toggleButtons(false);
      this._closeButton.interactive = false;
      this.visible = false;
      this._screenMask.show(false);

      resourceManager.get(
        "uiContainer:buttonContainer:stake:glow"
      ).visible = false;
    }
  }

  var gameStakeSelectionCreator = function (json) {
    return new GameStakeSelection(json);
  };

  var gameStakeSelectionInitialiser = function (json, buggy) {};

  var gameStakeSelectionFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "gameStakeSelection",
    gameStakeSelectionCreator,
    gameStakeSelectionInitialiser,
    gameStakeSelectionFilesRequired
  );
})();
